/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basicinformationaboutyourbusiness4Inputs */

const en_basicinformationaboutyourbusiness4 = /** @type {(inputs: Basicinformationaboutyourbusiness4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic information about your business`)
};

const de_basicinformationaboutyourbusiness4 = /** @type {(inputs: Basicinformationaboutyourbusiness4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Wichtigste zu deinem Unternehmen`)
};

/**
* | output |
* | --- |
* | "Basic information about your business" |
*
* @param {Basicinformationaboutyourbusiness4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const basicinformationaboutyourbusiness4 = /** @type {((inputs?: Basicinformationaboutyourbusiness4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basicinformationaboutyourbusiness4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_basicinformationaboutyourbusiness4(inputs)
	return de_basicinformationaboutyourbusiness4(inputs)
});
export { basicinformationaboutyourbusiness4 as "basicInformationAboutYourBusiness" }